import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
  icon: {   
    backgroundColor: 'white', 
    borderRadius: 2,
    border: '2px solid ' + theme.colors.primary[400],
    width: 20,
    height: 20,
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  iconChecked: {
    '&:before': {
      display: 'block',
      background: theme.colors.primary[400],
      width: 10,
      height: 10,
      marginTop: 3,
      marginLeft: 3,
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: theme.colors.primary[400],
    },
  },
});

const CheckboxUI = (props) => {
    let { classes, ...other } = props;
    // const classes = this.props;

    return (
        <Checkbox
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.iconChecked)}></span>}
            icon={<span className={classes.icon} />}
            {...other}
        />
    );
}

export default withStyles(styles)(CheckboxUI)